module.exports = __webpack_public_path__ + "0e77c8cb56c145fa79cb223edd58d1bf.svg";